module.exports = __webpack_public_path__ + "static/img/rectangularValveTechnical.5739663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/rectangularValveTechnical.png
// module id = BsHG
// module chunks = 1